export default {
    "0": {
        "RAN": 115,
        "Word Manipulation": 115,
        "Nonsense Word Repetition": 115,
        "Letter Sounds": 115,
        "Word Reading": 115,
        "Blending": 115,
        "NWF": 157.5,
        "Spelling": 854.7,
        "Vocabulary": 164.7,
        "Listening Comprehension": 453.9,
        "Oral Reading Fluency": 258.6,
        "Reading Comprehension": 138.1,
        "Letter Naming And Sounds": 115,
    },
    "1": {
        "RAN": 103,
        "Word Manipulation": 103,
        "Nonsense Word Repetition": 103,
        "Letter Sounds": 103,
        "Word Reading": 103,
        "Blending": 103,
        "NWF": 187.3,
        "Spelling": 623.8,
        "Vocabulary": 188.9,
        "Listening Comprehension": 387,
        "Oral Reading Fluency": 272.8,
        "Reading Comprehension": 130.9,
        "Letter Naming And Sounds": 103,
    },
    "2": {
        "RAN": 92,
        "Word Manipulation": 0,
        "Nonsense Word Repetition": 0,
        "Letter Sounds": 0,
        "Word Reading": 92,
        "Blending": 0,
        "NWF": 155.4,
        "Spelling": 488.4,
        "Vocabulary": 103.2,
        "Listening Comprehension": 228.5,
        "Oral Reading Fluency": 299.1,
        "Reading Comprehension": 98.1,
        "Letter Naming And Sounds": 92,
    },
    "3": {
        "RAN": 93,
        "Word Manipulation": 0,
        "Nonsense Word Repetition": 0,
        "Letter Sounds": 0,
        "Word Reading": 93,
        "Blending": 0,
        "NWF": 83.4,
        "Spelling": 383.4,
        "Vocabulary": 120.8,
        "Listening Comprehension": 215.9,
        "Oral Reading Fluency": 276,
        "Reading Comprehension": 97.1,
        "Letter Naming And Sounds": 93,
    },
    "4": {
        "RAN": 102,
        "Word Manipulation": 0,
        "Nonsense Word Repetition": 0,
        "Letter Sounds": 0,
        "Word Reading": 102,
        "Blending": 0,
        "NWF": 83.2,
        "Spelling": 242.3,
        "Vocabulary": 110.8,
        "Listening Comprehension": 244.2,
        "Oral Reading Fluency": 281.2,
        "Reading Comprehension": 87.7,
        "Letter Naming And Sounds": 102,
    },
    "5": {
        "RAN": 93,
        "Word Manipulation": 0,
        "Nonsense Word Repetition": 0,
        "Letter Sounds": 0,
        "Word Reading": 93,
        "Blending": 0,
        "NWF": 105.9,
        "Spelling": 235.9,
        "Vocabulary": 82.1,
        "Listening Comprehension": 207.6,
        "Oral Reading Fluency": 258,
        "Reading Comprehension": 80.2,
        "Letter Naming And Sounds": 93,
    },
    "6": {
        "RAN": 104,
        "Word Manipulation": 0,
        "Nonsense Word Repetition": 0,
        "Letter Sounds": 0,
        "Word Reading": 104,
        "Blending": 0,
        "NWF": 66.86,
        "Spelling": 205.6,
        "Vocabulary": 139.1,
        "Listening Comprehension": 167.7,
        "Oral Reading Fluency": 251.4,
        "Reading Comprehension": 89.4,
        "Letter Naming And Sounds": 104,
    }
}
